import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

// import { preset } from 'vue-cli-plugin-vuetify-preset-reply/preset'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  // preset,
  theme: {
    dark: false,
    themes: {
      light: {
        // primary: colors.teal.base,
        // primary: '#5878b8',
        // primary: '#0078c8', //ss light blue
        primary: '#293289',
        secondary: '#0E9CD8',
        // secondary: '#0078c8',
        // secondary: colors.orange.base,
        // accent: colors.blueGrey.base,
        //#002d55 ssdark blue
        accent: '#1428a0', //ssblue
        accent2: '#002d55', // ssdark blue
        etc: '#286ef1', //samsung blue
        error: colors.deepOrange.base,
        warning: colors.amber.base,
        info: colors.lightGreen.base,
        success: colors.indigo.base,
      },
      dark: {
        background: '#13547a',
        // background: colors.blueGrey.darken2
      },
    },
  },
})
